export default __webpack_public_path__ + "static/media/chime.960e981b.mp3";